/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import {
  Box,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import React from "react";

export default function Challenge() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Box
        bg={boxBg}
        p="30px"
        borderRadius="md"
        shadow="md"
      >
        <Text
          fontSize="md"
          color="gray.500"
          fontWeight="400"
          lineHeight="150%"
        >
          When CISOs and board members discuss cyber risk, their primary concern is its impact on business operations. They ask questions like: What is the financial cost of a security breach? How will it affect revenue and profits? Meanwhile, security teams prioritize patching efforts based on technical metrics such as CVE scores (Common Vulnerabilities and Exposures). This creates a strategic disconnect: leadership focuses on safeguarding critical assets to mitigate financial risk, while security teams concentrate on addressing severe vulnerabilities, often without considering the business impact.
          <br /><br />
          AIVRM bridges this gap by equipping security teams with insights into the financial impact of vulnerabilities on specific assets. This allows them to prioritize patching efforts on the vulnerabilities that pose the greatest threat to the business. By aligning the security team's priorities with those of CISOs and board members, AIVRM ensures a unified approach to cybersecurity, enhancing overall organizational resilience.
        </Text>
      </Box>
    </Box>
  );
}
